export default {
      id: "money-bag-usage",
      viewBox: "0 0 100 101",
      url: __webpack_public_path__ + "sprite.svg#money-bag",
      toString: function () {
        return this.url;
      }
    }